module.exports = __webpack_public_path__ + "img/icon_footer_02.a45cd9b2.svg";